import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import * as echarts from 'echarts';
import ElementUI from 'element-ui';
// 自定义主题
import '../theme/index.scss';
import './styles/index.scss';
import './styles/icon-font/iconfont.css';
import Loading from './components/saas-loading/index.js';
import PolyfillForElMessage from '@/utils/polyfillForElMessage.js';
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(Loading);
Vue.use(PolyfillForElMessage);
// 添加防止缩放代码
window.addEventListener(
    'wheel',
    function (event) {
        if (event.ctrlKey === true || event.metaKey) {
            event.preventDefault();
        }
    },
    { passive: false }
);
new Vue({
    router,
    store,
    render: (h) => h(App)
}).$mount('#app');
Vue.prototype.$echarts = echarts;
//异常的城市code
Vue.prototype.$abnormalCityCode = {
    419001: {
        name: '济源市',
        code: '419001'
    },
    429004: {
        name: '仙桃市',
        code: '429004'
    },
    429005: {
        name: '潜江市',
        code: '429005'
    },
    429006: {
        name: '天门市',
        code: '429006'
    },
    429021: {
        name: '神农架林区',
        code: '429021'
    },
    469001: {
        name: '五指山市',
        code: '469001'
    },
    469002: {
        name: '琼海市',
        code: '469002'
    },
    469005: {
        name: '文昌市',
        code: '469005'
    },
    469006: {
        name: '万宁市',
        code: '469006'
    },
    469007: {
        name: '东方市',
        code: '469007'
    },
    469021: {
        name: '定安县',
        code: '469021'
    },
    469022: {
        name: '屯昌县',
        code: '469022'
    },
    469023: {
        name: '澄迈县',
        code: '469023'
    },
    469024: {
        name: '临高县',
        code: '469024'
    },
    469025: {
        name: '白沙黎族自治县',
        code: '469025'
    },
    469026: {
        name: '昌江黎族自治县',
        code: '469026'
    },
    469027: {
        name: '乐东黎族自治县',
        code: '469027'
    },
    469028: {
        name: '陵水黎族自治县',
        code: '469028'
    },
    469029: {
        name: '保亭黎族苗族自治县',
        code: '469029'
    },
    469030: {
        name: '琼中黎族苗族自治县',
        code: '469030'
    },
    659001: {
        name: '石河子市',
        code: '659001'
    },
    659002: {
        name: '阿拉尔市',
        code: '659002'
    },
    659003: {
        name: '图木舒克市',
        code: '659003'
    },
    659004: {
        name: '五家渠市',
        code: '659004'
    },
    659005: {
        name: '北屯市',
        code: '659005'
    },
    659006: {
        name: '铁门关市',
        code: '659006'
    },
    659007: {
        name: '双河市',
        code: '659007'
    },
    659008: {
        name: '可克达拉市',
        code: '659008'
    },
    659009: {
        name: '昆玉市',
        code: '659009'
    },
    659010: {
        name: '胡杨河市',
        code: '659010'
    },
    659011: {
        name: '新星市',
        code: '659011'
    },
    五指山市: {
        name: '五指山市',
        code: '469001'
    },
    琼海市: {
        name: '琼海市',
        code: '469002'
    },
    文昌市: {
        name: '文昌市',
        code: '469005'
    },
    万宁市: {
        name: '万宁市',
        code: '469006'
    },
    东方市: {
        name: '东方市',
        code: '469007'
    },
    定安县: {
        name: '定安县',
        code: '469021'
    },
    屯昌县: {
        name: '屯昌县',
        code: '469022'
    },
    澄迈县: {
        name: '澄迈县',
        code: '469023'
    },
    临高县: {
        name: '临高县',
        code: '469024'
    },
    白沙黎族自治县: {
        name: '白沙黎族自治县',
        code: '469025'
    },
    昌江黎族自治县: {
        name: '昌江黎族自治县',
        code: '469026'
    },
    乐东黎族自治县: {
        name: '乐东黎族自治县',
        code: '469027'
    },
    陵水黎族自治县: {
        name: '陵水黎族自治县',
        code: '469028'
    },
    保亭黎族苗族自治县: {
        name: '保亭黎族苗族自治县',
        code: '469029'
    },
    琼中黎族苗族自治县: {
        name: '琼中黎族苗族自治县',
        code: '469030'
    },
    石河子市: {
        name: '石河子市',
        code: '659001'
    },
    阿拉尔市: {
        name: '阿拉尔市',
        code: '659002'
    },
    图木舒克市: {
        name: '图木舒克市',
        code: '659003'
    },
    五家渠市: {
        name: '五家渠市',
        code: '659004'
    },
    北屯市: {
        name: '北屯市',
        code: '659005'
    },
    铁门关市: {
        name: '铁门关市',
        code: '659006'
    },
    双河市: {
        name: '双河市',
        code: '659007'
    },
    可克达拉市: {
        name: '可克达拉市',
        code: '659008'
    },
    昆玉市: {
        name: '昆玉市',
        code: '659009'
    },
    胡杨河市: {
        name: '胡杨河市',
        code: '659010'
    },
    新星市: {
        name: '新星市',
        code: '659011'
    },
    仙桃市: {
        name: '仙桃市',
        code: '429004'
    },
    潜江市: {
        name: '潜江市',
        code: '429005'
    },
    天门市: {
        name: '天门市',
        code: '429006'
    },
    神农架林区: {
        name: '神农架林区',
        code: '429021'
    },
    济源市: {
        name: '济源市',
        code: '419001'
    }
};